import { render, staticRenderFns } from "./GlobalHero.vue?vue&type=template&id=08b6386f&scoped=true"
import script from "./GlobalHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalHero.vue?vue&type=style&index=0&id=08b6386f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6386f",
  null
  
)

export default component.exports